import { FormInstance, Radio, RadioGroupProps } from "antd"
import { Input } from "components/Input"
import React, { useEffect, useState } from "react"

import FatButton from "components/Button/FatButton/FatButton"
import Spacer from "components/Spacer"
import { Value } from "containers/Survey/types"
import { languages } from "lib/languages"
import { Gender } from "types/entity"
import { InputNames } from "types/props"
import styles from "./Radiobox.module.scss"

interface RadioboxValue {
  value: Value
  imgUrl?: string
  text: string
  onclick?: () => void
}

interface RadioboxProps extends RadioGroupProps {
  values: RadioboxValue[]
  formRef?: FormInstance
  honorificTitleValue?: number | undefined
}

const Radiobox: React.FC<RadioboxProps> = ({
  values,
  formRef,
  honorificTitleValue,
  ...radioGroupProps
}) => {
  const [selectedValue, setSelectedValue] = useState<Value | undefined>()

  useEffect(() => {
    setSelectedValue(radioGroupProps.value)
  }, [radioGroupProps])

  if (radioGroupProps.disabled) {
    radioGroupProps.value = `${radioGroupProps.value===0 ? "HOMME" : "FEMME"}`
    return (
       <Input {...(radioGroupProps as unknown as any)} style={{maxWidth:190, border:0}}/>
    )
  }

  const getHonorificTitle = (value: number | undefined) => {
    if (value === Gender.MALE) return languages.mister
    else if (value === Gender.FEMALE) return languages.miss
    return undefined
  }

  return (
    <div>
      <Radio.Group
        size="large"
        style={{ display: "none" }}
        {...(radioGroupProps as RadioGroupProps)}
        value={selectedValue}
      >
        {values.map((radioboxValue, key) => {
          return (
            <Radio.Button
              key={key}
              value={radioboxValue.value}
              checked={selectedValue === radioboxValue.value}
            >
              {radioboxValue.text}
            </Radio.Button>
          )
        })}
      </Radio.Group>
      <Spacer size={60} style={{ alignItems: "start" }}>
        {values.map((radioboxValue, key) => {
          return (
            <div key={key} style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <FatButton
                clicked={selectedValue === radioboxValue.value}
                onClick={() => {
                  radioboxValue.onclick && radioboxValue.onclick();
                  // obligé de passer la référene du formulaire
                  formRef &&
                    formRef.setFieldsValue({
                      [radioGroupProps.name as string]: radioboxValue.value,
                      [InputNames.HONORIFIC_TITLE as string]: radioboxValue.value,
                    })
                  formRef && formRef.validateFields()

                  setSelectedValue(radioboxValue.value)
                }}
                img={radioboxValue.imgUrl}
              >
                {radioboxValue.text}
              </FatButton>
              <div style={{ visibility: selectedValue === radioboxValue.value ? "visible" : "hidden" }}>
                <span className={styles.honorific}>
                  {languages.civility} : {getHonorificTitle(honorificTitleValue)}
                </span>
              </div>
            </div>
          )
        })}
      </Spacer>
    </div>
  )
}
export default Radiobox
